import React from 'react';
import { ActivityIcon, BookOpenIcon, CalendarDaysIcon, ClipboardListIcon, ClockIcon } from 'lucide-react';
import { differentiators } from '../data/content';
import { Mark, SectionTitle } from './ui/Section';
const icons = {
  book: BookOpenIcon,
  clock: ClockIcon,
  activity: ActivityIcon,
  calendar: CalendarDaysIcon,
  clipboard: ClipboardListIcon
};
export function Differentiators() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-45" data-mp="zdiu4644bktq">
      <div className="mx-auto max-w-5xl" data-id="element-46" data-mp="zf3onvqfn3rl">
        <SectionTitle data-id="element-47" data-mp="13dkmfonyr1wc">
          More than an exercise library. <Mark data-id="element-48" data-mp="13g5q8j7tnrwq">A complete professional system.</Mark>
        </SectionTitle>

        <ul className="mt-10 grid gap-x-8 gap-y-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-49" data-mp="18bujy5x5uel4">
          {differentiators.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="flex gap-4" data-id="element-50" data-mp="2js2mi7cldpws">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-teal-800" data-id="element-51" data-mp="2or5spv4b626c">
                  <Icon className="h-5 w-5 text-amber-300" aria-hidden="true" data-id="element-52" data-mp="bp3yjnsv38b1" />
                </span>
                <div data-id="element-53" data-mp="7mz26hb13xkp">
                  <h3 className="text-sm font-black uppercase leading-tight text-teal-950" data-id="element-54" data-mp="7nqqd72aqt0y">{item.title}</h3>
                  <p className="mt-1.5 text-sm leading-snug text-slate-600" data-id="element-55" data-mp="2mb45boduggz">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}